import Axios from "axios"
import { blobToFile, errorHandler as catcher, generateRequestHeaders } from "../../utils"
import api from '../../api'
import adapter from "./adapter"
import { TIMEOUT } from "../../constants"
import apiService from "../api/service"

function resolver(res){
  console.log(res)
  return res && res.data ? res.data : res
}

const service = {
  async get(id){
    return new Promise(function(resolve, reject){
      const url = `${api.base}${api.blogs}${id}/`
      const config = {
        timeout: TIMEOUT,
        headers: generateRequestHeaders()
      }

      Axios.get(url, config)
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)))
    })
  },

  async create(data){
    return new Promise(function(resolve, reject){
      let requestBody = adapter.formToRequestBody(data)
      console.log('requestBody', requestBody)

      apiService.create('blogs', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(catcher(err)))
    })
  },

  async update(id, data){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateRequestHeaders()
      }

      let requestBody = adapter.formToRequestBody(data)
      console.log('requestBody', requestBody)

      /* Axios */
      Axios.put(api.base+api.blogs+id+'/', requestBody, config)
      .then(res => resolve(resolver(res)))
      .catch(err => reject(catcher(err)))
    })
  },

  async handleImage(id, data){
    return new Promise(function(resolve){
      const needToUpdateThumbnail = needToUpdateImageChecker(id, data.thumbnail)
      const needToUpdateMainImage = needToUpdateImageChecker(id, data.image)

      console.log('handle image', needToUpdateMainImage, needToUpdateThumbnail)

      const formDataFields = []

      if(needToUpdateMainImage){
        formDataFields.push({
          key: 'imgMainImage',
          data: data.image
        })
      }

      if(needToUpdateThumbnail){
        formDataFields.push({
          key: 'imgThumbnail',
          data: data.thumbnail
        })
      }

      if(formDataFields.length > 0){
        buildFormData(formDataFields).then((formData) => {
          service.updateImage(id, formData)
        }).finally(() => resolve())
      } else {
        resolve()
      }
    })
  },

  async updateImage(id, formData){
    return new Promise(function(resolve, reject){
      let requestBody = formData
      console.log('requestBody', requestBody)

      const config = {
        headers: generateRequestHeaders()
      }

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.blogs}${id}/`, requestBody, config)
        .then(res => {
          console.log(res)
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => reject(catcher(err)))
        // resolve()
      } else {
        reject('id not provided.')
      }
    })
  },

  async handleGallery(id, filesByBlob){
    const response = await service.get(id)
    const blog = response.results
    const { blogsGalleries } = blog

    return await this.updateGallery(blogsGalleries, filesByBlob)
  },

  async updateGallery(data, filesByBlob){
    const result = []

    if(data && data.length > 0){
      for (let index = 0; index < data.length; index++) {
        const { pkGalleryId, deskripsiGambar } = data[index];
        const blob = deskripsiGambar[0]
        if(filesByBlob[blob]){
          const updated = await this.updateGalleryImageDirect(pkGalleryId, filesByBlob[blob])
          result.push({ index, updated })
        }
      }
    }

    return result
  },

  async updateGalleryImageDirect(id, file){
    const formData = new FormData()
    formData.append('imgGambar', file)

    const config = {
      headers: generateRequestHeaders()
    }

    const url = `${api.base}${api.blogs_gallery}${id}/`
    return await Axios.put(url, formData, config)
  },

  async handleGalleryDelete(data){
    const result = []

    if(data && data.length > 0){
      for (let index = 0; index < data.length; index++) {
        const pkId = data[index];

        const updated = await this.deleteGalleryImage(pkId)
        result.push({ index, updated })
      }
    }

    return result
  },

  async deleteGalleryImage(id){
    if(id){
      const config = {
        headers: generateRequestHeaders()
      }

      const url = `${api.base}${api.blogs_gallery}${id}/`
      return await Axios.delete(url, config)
    }

    return '400 | Gallery ID is not provided.'
  },

  async delete(id){
    return new Promise(function(resolve, reject){
      if(id){
        apiService.delete('blogs', id)
          .then(res => resolve(resolver(res)))
          .catch(err => reject(catcher(err)))
      } else {
        reject('id not provided.')
      }
    })
  },
}

// Helpers
export function getIdFromResponse(res){
  const KEY = 'blogId'

  return res[KEY] ? res[KEY]
    : res.data && res.data[KEY] ? res.data[KEY]
    : false
}

function needToUpdateImageChecker(id, data){
  return id && data && data.blob && data.blob.slice(0,4) === 'blob'
}

async function buildFormData(fields){
  const formData = new FormData()

  for (let index = 0; index < fields.length; index++) {
    const element = fields[index];

    const {name, blob, type} = element.data

    const file = await blobToFile(blob, name, type)
    formData.append(element.key, file)
  }

  return formData
}

export default service
